require("./brokerConvenienceTestAccordionBody.scss");
const PropTypes = require("prop-types");
const React = require("react");
const { OKLink } = require("commonsComponents/OKLink");
const {
    OKCollapsingToggler,
} = require("commonsComponents/OKCollapsingToggler");
class BrokerConvenienceTestAccordionBody extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { disabled } = this.props;
        if (!disabled) {
            this.props.onAccordionClick(this.props.id);
        }
    }

    render() {
        const { information, togglerText } = this.props;
        return (
            <div className="br-accordion-body">
                <p className="br-accordion-body__text">{information}</p>
                <div
                    className={"br-accordion-header__columns__title--toggler"}
                    onClick={this.handleClick}
                >
                    <OKLink modifier="emphasize">{togglerText}</OKLink>
                    <OKCollapsingToggler
                        isIconSecondary={true}
                        isIconFixed={true}
                        isExpanded={true}
                    />
                </div>
            </div>
        );
    }
}

BrokerConvenienceTestAccordionBody.propTypes = {
    information: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    togglerText: PropTypes.string.isRequired,
};

module.exports = BrokerConvenienceTestAccordionBody;
